import React from "react";
import { Table } from "rsuite";

import { LOCAL_STORAGE_TRAFFIC_STAT_FILTERS, LOCAL_STORAGE_DELAYED_SERVICE_CHANGE } from "const/localStorageKeys";
import { renderMoney, getFormattedTime, getISOTime } from "utils/helpers";
import { transformed_service_data } from "const";
import CommonTable from "components/Payments/CommonPaymentsTable";
import * as S from "../styled.js";

const { Column, HeaderCell, Cell } = Table;


export default ({
    data = [],
    // service,
    // setService,
    isSupplier,
    loading = false,
    openModalRequestPayment,
    // setSelectedRequest,
    height,
    checkedStatus = [],
    withFilters = false
}) => {

    // const statusLabels = ["Pending", "Ready for payment", "Paid"];

    const columns = [
        {
            id: "service",
            label: "Service",
            dataKey: "service",
            value: ({ service }) => service,
            width: 100,
            // flexGrow: 1,
            minWidth: !withFilters ? 150 : null,
            align: "left",
        },
        {
            id: "trafficPeriod",
            label: "Traffic period",
            value: ({ date_from, date_to }) => (
                `${getFormattedTime(date_from.replace(" ", "T"))} - ${getFormattedTime(date_to.replace(" ", "T"))}`
            ),
            width: 200,
            flexGrow: !withFilters ? 2 : null,
            minWidth: !withFilters ? 200 : null,
            align: "center"
        },
        {
            id: "date",
            label: "Date",
            dataKey: "date2",
            width: 150,
            flexGrow: !withFilters ? 2 : null,
            minWidth: !withFilters ? 200 : null,
            align: "center"
        },
        {
            id: "amount",
            label: "Amount",
            value: ({ agr_send, currency_name }) => renderMoney(agr_send, currency_name),
            width: 150,
            flexGrow: !withFilters ? 2 : null,
            minWidth: !withFilters ? 200 : null,
            align: "center"
        },
        {
            id: "status",
            label: "Status",
            value: ({ status_str }) => status_str,
            width: 150,
            flexGrow: !withFilters ? 2 : null,
            minWidth: !withFilters ? 200 : null,
            align: "center"
        },
    ];

    if (withFilters) {
        columns.unshift({
            id: "account",
            label: "Account",
            value: ({ account_name, account_manager_name }) => `${account_name} / ${account_manager_name || "no manager"}`,
            flexGrow: 2,
            minWidth: 300,
            align: "center"
        });
    }

    const tableActions = (
        <Column width={210} key="table__actions">
            <HeaderCell> </HeaderCell>
            <Cell>
                {rowData => {

                    return (
                        <S.StyledTableActions alignEnd>

                            {rowData.status === 1 &&
                                <S.StyledTableButton
                                    onClick={() => openModalRequestPayment(rowData)}
                                >
                                    Request payment
                                </S.StyledTableButton>
                            }

                            <S.StyledTableButton
                                onClick={(e) => {
                                    const dateFrom = new Date(rowData.date_from.replace(" ", "T"));
                                    const dateTo = new Date(rowData.date_to.replace(" ", "T"));

                                    const rowService = transformed_service_data[rowData.service];

                                    const filtersDefaultValue = {
                                        range: [getISOTime(dateFrom), getISOTime(dateTo)],
                                        start_end_date: [dateFrom, dateTo],
                                        ...(isSupplier ? { supplier_id: rowData.account_id } : { dialer_id: rowData.account_id }),
                                        group_checkbox: ["originator_name"],
                                        show_reliable: true,
                                        show_not_reliable: true
                                    };

                                    localStorage.setItem(LOCAL_STORAGE_TRAFFIC_STAT_FILTERS, JSON.stringify(filtersDefaultValue));

                                    window.open(`/traffic-reports?service=${rowData.service}`);

                                    // localStorage.setItem(LOCAL_STORAGE_DELAYED_SERVICE_CHANGE, JSON.stringify(rowService));
                                }}
                            >
                                Details
                            </S.StyledTableButton>

                        </S.StyledTableActions>
                    );
                }}
            </Cell>
        </Column>
    );

    const filteredData = withFilters && checkedStatus.length
        ? data.filter(item => {
            // exclude pended
            if (item.status === 2)
                return false;

            // exclude all except ready for payment
            if (checkedStatus.includes(1) && item.status !== 1) {
                return false;
            }

            return true;
        })
        : data;

    return (
        <CommonTable
            height={height}
            data={filteredData}
            headerHeight={40}
            loading={loading}
            columns={columns}
            tableActions={tableActions}
        />
    );
};
